"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectWithMessage = exports.redirect = void 0;
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));
/**
 * Redirects the browser to the specified URL
 * 
 * @param url The URL to redirect to
 */
const redirect = url => {
  window.location.href = url;
};

/**
 * Redirects the browser to the specified URL with message parameters
 * 
 * @param url The URL to redirect to
 * @param msg Optional message to include in the URL
 * @param msgType Optional message type to include in the URL
 */
exports.redirect = redirect;
const redirectWithMessage = (url, msg = null, msgType = null) => {
  const redirectURL = new _url.default(url || '', window.location.href);
  if (msg !== null) {
    redirectURL.searchParams.set('__message__', msg);
  }
  if (msgType !== null) {
    redirectURL.searchParams.set('__messageType__', msgType);
  }
  window.location.href = redirectURL.href;
};
exports.redirectWithMessage = redirectWithMessage;